export let isServerEnv = 'undefined' === typeof window;
const ENTRY_PAGE_ALL_PARAMS = 'entryPageAllPArams';
let getHrefParamFromLocation = function(paramName, newHref) {
  let href =
    newHref ||
    decodeURIComponent(
      (global.location && (global.location.search || global.location.hash)) ||
        ''
    ).substr(1);
  let reg = new RegExp('(^|&|\\?)' + paramName + '=([^&]*)(&|$)');
  let matchResult = href.match(reg);
  let param = matchResult ? decodeURIComponent(matchResult[2]) : '';
  return param;
};

let getHrefParamFromLocationUncode = function(paramName, newHref) {
  let href =
    newHref ||
    (
      (global.location && (global.location.search || global.location.hash)) ||
      ''
    ).substr(1);
  let reg = new RegExp('(^|&|\\?)' + paramName + '=([^&]*)(&|$)');
  let matchResult = href.match(reg);
  let param = matchResult ? decodeURIComponent(matchResult[2]) : '';
  return param;
};
let prevAction = 'init';
let staticEventLists = [];
let sendImmediate = false;
let immediateSendEvent = ['login_fail'];

/**
 * 浏览器类型
 */
const getBrowser = () => {
  let userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('firefox') >= 0) {
    return 'Firefox';
  }
  if (userAgent.indexOf('opera') >= 0 || userAgent.indexOf('opr') >= 0) {
    return 'Opera';
  }
  if (userAgent.indexOf('chrome') >= 0) {
    return 'Chrome';
  }
  if (userAgent.indexOf('safari') >= 0) {
    return 'Safari';
  }
  if (userAgent.indexOf('trident') >= 0) {
    return 'Internet Explorer';
  }
  return 'Other';
};

const getPhoneModel = () => {
  let userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('windows phone') >= 0) {
    return 'Windows Phone';
  }
  if (userAgent.indexOf('win') >= 0) {
    return 'Windows';
  }
  if (userAgent.indexOf('android') >= 0) {
    return 'Android';
  }
  if (userAgent.indexOf('linux') >= 0 || userAgent.indexOf('cros') >= 0) {
    return 'Linux';
  }
  if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0) {
    return 'iOS';
  }
  if (userAgent.indexOf('mac') >= 0) {
    return 'Mac';
  }
  return 'Other';
};

export default {
  curentLang: '',
  query: null,
  route: null,
  isServerEnv: 'undefined' === typeof window,
  global: 'undefined' === typeof window ? global : window,
  isFirstPlay: true,
  // 获取包名 运营定义的，实际后台不存在，用来区分看统计数据
  packageName:
    window.location.host === 'naisitsu.37games.com'
      ? 'com.jp.beauty.qst' // 骑士版江美H5包名
      : 'com.jp.beauty.pc', // 默认版江美H5包名
  init() {
    this.initQuery();
    this.initLanguage();
  },
  initQuery() {
    if (this.rootVm && this.route) {
      this.query = this.route.query;
    }
  },

  setRoute(route) {
    this.route = route;
  },
  initLanguage() {
    if (this.query) {
      this.curentLang = this.query['language'];
    }
  },
  setRouterQuery(query) {
    this.query = query;
  },
  getQuery() {
    return this.query;
  },

  getParamFromRouter(paramName) {
    var paramVal = '';
    if (this.route) {
      paramVal = this.route.query[paramName];
    }
    return paramVal;
  },

  getHrefParam(paramName) {
    if (isServerEnv) {
      return this.getParamFromRouter(paramName);
    }
    return getHrefParamFromLocation(paramName);
  },
  getHrefParamUndecode(paramName, href) {
    return getHrefParamFromLocationUncode(paramName, href);
  },
  getLanguages() {
    return this.getHrefParam('appLanguage') || this.getHrefParam('language');
  },

  getMainHost() {
    return this.global.location.host.match(/\w+\.com$/)[0];
  },

  getParamQuery() {
    var queryStr = '';
    if (isServerEnv || this.rootVm !== undefined) {
      queryStr = getHrefParamFromLocation(this.route.query);
    } else {
      var href = global.location.href;
      queryStr = href.replace(/.*(?=\?)/, '').replace(/\#(w*\/)*/, '');
    }
    return queryStr;
  },
  getCurrentHref() {
    var href = '';
    if (isServerEnv || this.rootVm !== undefined) {
      href = '';
    } else {
      href = global.location.href;
    }
    return href;
  },

  getLocationSearch() {
    var search = '';
    if (isServerEnv || this.rootVm !== undefined) {
      search = '';
    } else {
      search = global.location.search;
    }
    return search;
  },

  getLclStorageItem(name) {
    var res = null;
    try {
      if ('undefined' != typeof this.global.localStorage) {
        res = JSON.parse(this.global.localStorage.getItem(name));
        return res;
      }
    } catch (e) {
      console.error(e);
      console.log(name);
    }

    return res;
  },
  setLclStorageItem(name, val) {
    if (this.global.localStorage) {
      return this.global.localStorage.setItem(name, JSON.stringify(val));
    }
  },
  setCookie(name, value, time) {
    var foreverTime = new Date();
    foreverTime.setFullYear(foreverTime.getFullYear() + 3000);
    document.cookie = `${name}=${value};domain=${this.getMainHost()};expires=${time ||
      foreverTime.toGMTString()}`;
  },
  getCookie(name) {
    var arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
    else return null;
  },
  stateRenderTime() {
    let startTime = parseInt(
      this.getHrefParam('timestamp') ||
        this.getHrefParam('timeStamp') ||
        this.getHrefParam('time_stamp')
    );
    if (!isServerEnv) {
      this.global.addEventListener('load', function() {
        let completeTime = window.performance.timing.domComplete - startTime;
        let interactiveTime =
          window.performance.timing.domInteractive - startTime;
        console.log('completeTime: ');
        console.log(completeTime);
        console.log('interactiveTime: ');
        console.log(interactiveTime);
      });
    }
  },
  showMountedTime() {
    let startTime = parseInt(
      this.getHrefParam('timestamp') ||
        this.getHrefParam('timeStamp') ||
        this.getHrefParam('time_stamp')
    );
    let now = new Date().getTime();
    console.log('mountedTime: ');
    console.log(now - startTime);
  },
  storeEntryParams() {
    let storeParams = this.getAllWebviewEntryParams();
    if (null != storeParams) {
      return false;
    }
    let params = {
      Isdblink: this.getHrefParam('Isdblink'),
      advertise: this.getHrefParam('advertise'),
      androidid: this.getHrefParam('androidid'),
      appLanguage: this.getHrefParam('appLanguage'),
      apps: this.getHrefParam('apps'),
      battery: this.getHrefParam('battery'),
      channelId: this.getHrefParam('channelId'),
      country: this.getHrefParam('country'),
      cpOrderId: this.getHrefParam('cpOrderId'),
      cpProductId: this.getHrefParam('cpProductId'),
      customUserId: this.getHrefParam('customUserId'),
      deepLinkURL: this.getHrefParam('deepLinkURL'),
      devicePlate: this.getHrefParam('devicePlate'),
      gameId: this.getHrefParam('gameId'),
      gpid: this.getHrefParam('gpid'),
      sdkToken: this.getHrefParam('sdkToken'),
      imei: this.getHrefParam('imei'),
      isFirst: this.getHrefParam('isFirst'),
      language: this.getHrefParam('language'),
      loginAccount: this.getHrefParam('loginAccount'),
      loginSign: this.getHrefParam('loginSign'),
      loginTimestamp: this.getHrefParam('loginTimestamp'),
      loginUID: this.getHrefParam('loginUID'),
      mac: this.getHrefParam('mac'),
      netType: this.getHrefParam('netType'),
      osVersion: this.getHrefParam('osVersion'),
      packageName: this.getHrefParam('packageName'),
      packageVersion: this.getHrefParam('packageVersion'),
      phoneModel: this.getHrefParam('phoneModel'),
      productId: this.getHrefParam('productId'),
      ptCode: this.getHrefParam('ptCode'),
      publishPlatForm: this.getHrefParam('publishPlatForm'),
      ratio: this.getHrefParam('ratio'),
      remark: this.getHrefParam('remark'),
      roleId: this.getHrefParam('roleId'),
      roleLevel: this.getHrefParam('roleLevel'),
      roleName: this.getHrefParam('roleName'),
      sdkVersion: this.getHrefParam('sdkVersion'),
      serverId: this.getHrefParam('serverId'),
      thirdPlatForm: this.getHrefParam('thirdPlatForm'),
      timeStamp: this.getHrefParam('timeStamp'),
      timeZone: this.getHrefParam('timeZone'),
      ueAndroidId: this.getHrefParam('ueAndroidId'),
      userId: this.getHrefParam('userId'),
      userMode: this.getHrefParam('userMode'),
      userName: this.getHrefParam('userName'),
      zone: this.getHrefParam('zone')
    };
    sessionStorage.setItem(ENTRY_PAGE_ALL_PARAMS, JSON.stringify(params));
  },
  getAllWebviewEntryParams() {
    let params = {};
    try {
      params = JSON.parse(sessionStorage.getItem(ENTRY_PAGE_ALL_PARAMS)) || {};
    } catch (e) {}
    return params;
  },
  getHrefParamObj() {
    let paramsStr = window.location.search.substr(1);
    let res = {};
    let paramsArr = [];
    if (paramsStr.indexOf('&') >= 0) {
      paramsArr = paramsStr.split('&');
    } else if (paramsStr) {
      paramsArr = [paramsStr];
    }

    paramsArr.map((item) => {
      let result = item.split('=');
      res[result[0]] = result[1];
    });

    return res;
  },
  assignParamsObj(obj1, obj2) {
    let newObj1 = Object.assign({}, obj1);
    let newObj2 = Object.assign({}, obj2);
    return Object.assign(newObj1, newObj2);
  },
  objParamsToStrParams(obj) {
    let res = [];
    for (var key in obj) {
      res.push(`${key}=${obj[key]}`);
    }
    return res.join('&');
  },
  hrefAddParam(url, key, value) {
    if (url.indexOf('?') >= 0) {
      let reg = new RegExp('(\\?|&)' + key + '=', 'g');
      reg.lastIndex = 0;
      if (!reg.test(url)) {
        return url + `&${key}=${value}`;
      } else {
        return url;
      }
    } else {
      return url + `?${key}=${value}`;
    }
  },
  addEvenListener(callback) {
    let addEvenListener = window.addEventListener || window.attatchEvent;
    let messageEvent = window.addEventListener ? 'message' : 'onmessage';
    addEvenListener(messageEvent, callback, false);
  },
  removeEventListener(callback) {
    let removeEvenListener = window.removeEventListener || window.detachEvent;
    let messageEvent = window.removeEventListener ? 'message' : 'onmessage';
    removeEvenListener(messageEvent, callback, false);
  },
  setIsFirstPlay(val, userId) {
    this.userId = userId;
    let firstPlayObj = JSON.parse(
      window.localStorage.getItem('firstPlayObj') || '{}'
    );
    if (!val) {
      val = false;
    }
    if (firstPlayObj[userId]) {
      val = this.judgeIsNewUser();
    }
    // 根据isFirst区别设置firstTime
    let tmpFirstTime = val ? Date.now() : Date.now() - 48 * 60 * 60 * 1000;
    firstPlayObj.prev = userId;
    firstPlayObj[userId] = {
      isFirst: val,
      firstPlayTime:
        (firstPlayObj[userId] && firstPlayObj[userId].firstPlayTime) ||
        tmpFirstTime
    };
    this.isFirstPlay = val;
    window.localStorage.setItem('firstPlayObj', JSON.stringify(firstPlayObj));
  },
  judgeIsNewUser() {
    if (!this.userId) {
      return true;
    }
    let firstPlayObj = JSON.parse(
      window.localStorage.getItem('firstPlayObj') || '{}'
    );
    let playerInfo = firstPlayObj[this.userId];
    let firstTime = Date.now();
    if (playerInfo) {
      firstTime = playerInfo.firstPlayTime;
    }
    let date = new Date(firstTime);
    let now = Date.now();
    let playTime = Math.floor((now - date.getTime()) / (60 * 60 * 1000));
    let isNew = playTime < 48 ? true : false;
    return isNew;
  },
  statistics(eventName, data) {
    let isNewUser = this.judgeIsNewUser();
    let curTime = window.now_time || new Date().getTime() || '';
    staticEventLists.push({
      event: eventName,
      is_new: isNewUser,
      prev: prevAction,
      userName: this.userName,
      time: curTime,
      ...data
    });
    if (eventName === 'click_close_window') {
      sendImmediate = true;
    }
    if (immediateSendEvent.indexOf(eventName) !== -1) {
      sendImmediate = true;
    }
    if (sendImmediate) {
      // 重置队列推入的打点归属
      staticEventLists = staticEventLists.map((item) => {
        item.userName = this.userName;
        item.is_new = isNewUser;
        return item;
      });
      if (immediateSendEvent.indexOf(eventName) !== -1) {
        sendImmediate = false;
      }
      if (window.dataLayer) {
        staticEventLists = staticEventLists.filter((item) => !item.isSend);
        let length = staticEventLists.length;
        if (!length) {
          return;
        }
        for (let i = 0; i < length; i++) {
          let item = staticEventLists[i];
          let isSend = item.isSend;
          if (isSend) {
            continue;
          }
          window.dataLayer.push(item);
          item.isSend = true;
        }
      }
    }
    if (eventName === 'login_success') {
      sendImmediate = true;
    }

    prevAction = eventName;
  },
  ajaxStatistics(eventName, eventValue, eventType, loginAccount, serverId) {
    const isTest = this.getHrefParam('test') == 1;
    const plat = window.pageInfo['platform'];

    const statisticsApiKey = isTest
      ? 'fkbyQgenICVgwBhtTpwz0MuAo7w7yOVD'
      : 'LN9ErNZJlpr8F3YnVOIynAb0hRp8uYWU';

    const statisticsUrl = `https://${
      isTest ? 'test-' : ''
    }jph5callback.37games.com/api/v1/mjp_h5`;

    let paramsArr = [
      `apikey=${statisticsApiKey}`,
      `gameID=${window.gameId}`,
      `event=${eventName || ''}`,
      `loginAccount=${loginAccount || ''}`,
      `gameServerID=${serverId || ''}`,
      `fbc=${this.getCookie('_fbc') || ''}`,
      `fbp=${this.getCookie('_fbp') || ''}`,
      `phoneModel=${getPhoneModel()}`,
      `deviceForm=${getBrowser()}`,
      `ext1=${encodeURIComponent(window.location.href)}`,
      `ext2=${JSON.stringify(this.getHrefParamObj())}`,
      `ext4=jp-h5`,
      `ext5=${window.gameInfo['ENNAME']}`,
      `ext6=${new Date().getTime()}`,
      `ext7=${eventValue || ''}`,
      `ext8=${eventType || ''}`,
      `ext23=${this.packageName}`
    ];

    let commonParams =
      window.globalGetLinkParams && window.globalGetLinkParams();
    if (commonParams) {
      Object.keys(commonParams).forEach((key) => {
        paramsArr.push(`${key}=${commonParams[key]}`);
      });
    }

    const statisticsImg = document.createElement('img');
    statisticsImg.src = `${statisticsUrl}?${paramsArr.join('&')}`;
  }
};
